export { default as Switch } from './Switch'
